// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"121c6015","310":"11262c8e","854":"6e5f98a9"}[chunkId] + ".chunk.css";
};